// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__21JT-","title":"Header_title__3GI6_","side":"Header_side__13gaG"};